'use strict';

module.exports = Object.freeze({
	"EHRMS_001": {
	  "name": "使用者帳號認證信",
	  "zh_TW": {
		"subject": "【重要通知】104 HR Max系統帳號認證",
		"content": "<p>[@USER_NAME@]先生/小姐，您好,</p><p>您的104HRMax帳號「<b>[@USER_ACCOUNT@]</b>」已被建立。</p><p>為了您帳戶安全，此連結僅<spanstyle=\"color:#ff843f;\">24小時內有效</span>。</p><p>請點擊下方藍字，依照指令操作即能啟用您的帳號。</p>{{>zh_TW/buttonbtnText='啟用帳號'}}<p>或複製前往以下連結：</p><p>{{>zh_TW/link}}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[ImportantNotification]104HRMaxsystemaccountverification",
		"content": "<p>Hello, Mr./Ms. [@USER_NAME@], </p><p>Your 104 HR Max account “[@USER_ACCOUNT@]” has been created. </p><p>For your account security, this link is<span style=\"color: #ff843f;\"> valid only for 24 hours. </span>。</p><p>Please click the following blue text to activate your account according to the instructions. </p>{{> en_US/button btnText='Activate account '}}<p>Or copy and go to the following link: </p><p>{{> en_US/link }}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】104 HR Max系统账号认证",
		"content": "<p>[@USER_NAME@]先生/小姐，您好,</p><p>您的 104 HR Max 账号 「<b>[@USER_ACCOUNT@]</b>」已建立。</p><p>为了您账户安全，此链接仅<span style=\"color: #ff843f;\"> 24 小时内有效</span>。</p><p>请点击下方蓝字，依照指令操作即能启用您的账号。</p>{{> zh_CN/button btnText='启用账号'}}<p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"EHRMS_002": {
	  "name": "使用者密碼重新設定認證信",
	  "zh_TW": {
		"subject": "【重要通知】104 HR Max系統密碼重新設定",
		"content": "<p>[@USER_NAME@]先生/小姐，您好,</p><p>我們收到了申請重設您的 104 HR Max 密碼的要求，提醒您: 如未做過變更動作，煩請儘速聯絡貴司管理者。</p><p>為了您帳戶安全，此連結僅<span style=\"color: #ff843f;\"> 24 小時內有效</span>。</p><p>請點擊下方藍字，依照指令操作即能完成重新設定密碼。</p>{{> zh_TW/button btnText='重設密碼'}}<p>或複製前往以下連結：</p><p>{{> zh_TW/link }}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] 104 HR Max system password reset",
		"content": "<p>Hello, Mr./Ms. [@USER_NAME@], </p><p>We received your request to reset your 104 HR Max password. As a reminder, if you did not make the change, please contact your administrator as soon as possible. </p><p>For your account security, this link is<span style=\"color: #ff843f;\"> valid only for 24 hours</span>.</p><p>Please click the following blue text to reset your password according to the instructions.</p>{{> en_US/button btnText='Reset password'}}<p>Or copy and go to the following link: </p><p>{{> en_US/link }}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】104 HR Max系统密码重新设定",
		"content": "<p>[@USER_NAME@]先生/小姐，您好,</p><p>我们收到了申请重设您的 104 HR Max 密码的要求，提醒您: 如未做过变更动作，烦请尽快联络贵司管理者。</p><p>为了您账户安全，此链接仅<span style=\"color: #ff843f;\"> 24 小时内有效</span>。</p><p>请点击下方蓝字，依照指令操作即能完成重新设定密码。</p>{{> zh_CN/button btnText='重设密码'}}<p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"EHRMS_003": {
	  "name": "使用者E-mail重新設定認證信",
	  "zh_TW": {
		"subject": "【重要通知】104 HR Max系統E-mail重新設定",
		"content": "<p>[@USER_NAME@]先生/小姐，您好,</p><p>我們收到了申請重設您的 104 HR Max 帳號 Email 的要求，提醒您: 如未做過變更動作，煩請儘速聯絡貴司管理者。</p><p>為了您帳戶安全，此連結僅<span style=\"color: #ff843f;\"> 24 小時內有效</span>。</p><p>請點擊下方藍字，依照指令操作即能完成重新認證您的 Email。</p>{{> zh_TW/button btnText='重設 Email'}}<p>或複製前往以下連結：</p><p>{{> zh_TW/link }}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] 104 HR Max system e-mail address reset",
		"content": "<p>Hello, Mr./Ms. [@USER_NAME@], </p><p>We received your request to reset your 104 HR Max account’s e-mail address. As a reminder, if you did not make the change, please contact your administrator as soon as possible. </p><p>For your account security, this link is<span style=\"color: #ff843f;\"> valid only for 24 hours</span>.</p><p>Please click the following blue text to reverify your e-mail address according to the instructions. </p>{{> en_US/button btnText='Reset e-mail address'}}<p>Or copy and go to the following link: </p><p>{{> en_US/link }}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】104 HR Max系统E-mail重新设定",
		"content": "<p>[@USER_NAME@],先生/小姐，您好,</p><p>我们收到了申请重设您的 104 HR Max 账号 Email 的要求，提醒您: 如未做过变更动作，烦请尽快联络贵司管理者。</p><p>为了您账户安全，此链接仅<span style=\"color: #ff843f;\"> 24 小时内有效</span>。</p><p>请点击下方蓝字，依照指令操作即能完成重新认证您的 Email。</p>{{> zh_CN/button btnText='重设 Email'}}<p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"EHRMS_004": {
	  "name": "【重要通知】104 HR Max系統生效作業失敗通知",
	  "zh_TW": {
		"subject": "【重要通知】104 HR Max系統生效作業失敗通知",
		"content": "<p>[@USER_NAME@]先生/小姐，您好,</p><p>生效作業執行日期 生效作業，有下列失敗資料，請儘速至系統工具/作業執行紀錄查詢失敗原因。[@EFF_TABLE@]</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] Notification of failed 104 HR Max system validation",
		"content": "<p>Hello, Mr./Ms. [@USER_NAME@], </p><p>The failure data of the validation operation performed on the validation execution date is as follows. Please go to System Tools/Operation Execution Records to check the reason of the failure as soon as possible. [@EFF_TABLE@] </p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】104 HR Max系统生效作业失败通知",
		"content": "<p>[@USER_NAME@]先生/小姐，您好,</p><p>生效作业执行日期 生效作业，有下列失败数据，请尽快至系统工具/作业执行纪录查询失败原因。[@EFF_TABLE@]</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PORTAL_010": {
	  "name": "【重設密碼】-申請者",
	  "zh_TW": {
		"subject": "【重要通知】重設密碼通知",
		"content": "<p>您好,</p><p>我們收到了您申請重設密碼的要求，提醒您: 如未做過變更動作，煩請儘速聯絡貴司管理者。</p><p>為了您帳戶安全，此連結僅 <span style=\"color: #ff843f;\">30 分鐘內有效</span>。</p><p>請點擊下方按鈕或是複製連結，依照指令操作即能完成重新設定密碼喔。</p><p>{{> zh_TW/button btnText='重設密碼'}}</p><p>或複製前往以下連結：</p><p>{{> zh_TW/link }}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] Password reset notification",
		"content": "<p>Hello, </p><p>We received your password reset request. As a reminder, if you did not make the change, please contact your administrator as soon as possible. </p><p>For your account security, this link is<span style=\"color: #ff843f;\"> valid only for 30 minutes</span>.</p><p>Please click the following button or copy the link to reset your password according to the instructions. </p><p>{{> en_US/button btnText='Reset password '}}</p><p>Or copy and go to the following link: </p><p>{{> en_US/link }}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】重设密码通知",
		"content": "<p>您好,</p><p>我们收到了您申请重设密码的要求，提醒您: 如未做过变更动作，烦请尽快联络贵司管理者。</p><p>为了您账户安全，此链接仅 <span style=\"color: #ff843f;\">30 分钟内有效</span>。</p><p>请点击下方按钮或是复制链接，依照指令操作即能完成重新设定密码喔。</p><p>{{> zh_CN/button btnText='重设密码'}}</p><p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PORTAL_020": {
	  "name": "【重設密碼】-管理者",
	  "zh_TW": {
		"subject": "【重要通知】重設密碼通知",
		"content": "<p>您好,</p></p><p>員工【[@EMP_NAME@]】於 [@APPLY_DATETIME@] 申請重設登入密碼的要求，建議您先與該員工確認是否有申請重設登入密碼 ，如確認無誤，請點擊下方連結，進入頁面重新預設該員工登入密碼，並依照指令操作後，即能完成重新設定登入密碼喔。完成後也請記得通知該員工喔 !</p><p>{{> zh_TW/button text='重設員工登入密碼按鈕'}}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] Password reset notification",
		"content": "<p>Hello, </p></p><p>The employee【[@EMP_NAME@]】submitted a login password reset request at [@APPLY_DATETIME@]. It is advisable to confirm such login password reset request with the employee first. If the request is confirmed, please click the following link to enter the page and reset the login password of the employee according to the instructions. After the password is reset, please remember to notify the employee! </p><p>{{> en_US/button text='Staff login password reset button'}}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】重设密码通知",
		"content": "<p>您好,</p></p><p>员工【[@EMP_NAME@]】于 [@APPLY_DATETIME@] 申请重设登入密码的要求，建议您先与该员工确认是否有申请重设登入密码 ，如确认无误，请点击下方链接，进入页面重新默认该员工登入密码，并依照指令操作后，即能完成重新设定登入密码。完成后也请记得通知该员工喔 !</p><p>{{> zh_CN/button text='重设员工登入密码按钮'}}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PORTAL_030": {
	  "name": "【重要通知】Portal帳號首次認證",
	  "zh_TW": {
		"subject": "【重要通知】Portal帳號首次認證",
		"content": "<p>[@EMP_NAME@] 您好：</p><p>您的 Portal 帳號 「[@USER_ACCOUNT@]」已被建立，公司代號為「[@APP_COMPANY_CODE@]」。</p><p>為了您帳戶安全，此連結僅 <span style=\"color: #ff843f;\">24 小時內有效</span>。<br />請點擊下方藍字，依照指令操作即能啟用您的帳號。</p><p>{{> zh_TW/button btnText='啟用帳號'}}</p><p>或複製前往以下連結：</p><p>{{> zh_TW/link }}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] First time Portal account verification",
		"content": "<p>Hello, [@EMP_NAME@], </p><p>Your Portal account “[@USER_ACCOUNT@]” has been created, and the company code is “[@APP_COMPANY_CODE@].” </p><p>For your account security, this link is <span style=\"color: #ff843f;\">valid only for 24 hours</span>.<br />Please click the following blue text to activate your account according to the instructions. </p><p>{{> en_US/button btnText='Activate account '}}</p><p>Or copy and go to the following link: </p><p>{{> en_US/link }}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】Portal账号首次认证",
		"content": "<p>[@EMP_NAME@] 您好：</p><p>您的 Portal 账号 「[@USER_ACCOUNT@]」已被建立，公司代号为「[@APP_COMPANY_CODE@]」。</p><p>为了您账户安全，此链接仅 <span style=\"color: #ff843f;\">24 小时内有效</span>。<br />请点击下方蓝字，依照指令操作即能启用您的账号。</p><p>{{> zh_CN/button btnText='启用账号'}}</p><p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PAYSHEET_010": {
	  "name": "變更薪資袋密碼通知",
	  "zh_TW": {
		"subject": "變更薪資袋密碼通知",
		"content": "<p>[@員工姓名@]先生/小姐，您好,</p><br><br>您的電子薪資袋登入密碼即將於<span style=\"color: #ff843f;\">[@到期時間@]</span>到期，<br><br>請您儘快前往「<b>ePortal>個人專區>個人資料查詢>帳號安全</b>」內維護變更您的密碼，謝謝。<br><br><br>(本郵件為系統自動發送，請勿直接回覆)"
	  },
	  "en_US": {
		"subject": "Payroll password change notification",
		"content": "<p>Hello, Mr./Ms. [@員工姓名@],</p><br><br>Your electronic payroll login password will soon expire at <span style=\"color: #ff843f;\">[@到期時間@]</span>. <br><br>Please go to “<b>ePortal > Personal Zone>Profile Search>Account Security</b>” to maintain and change your password as soon as possible. <br><br><br>(This email is automatically sent by the system. Please do not reply.)"
	  },
	  "zh_CN": {
		"subject": "变更薪资袋密码通知",
		"content": "<p>[@員工姓名@]先生/小姐，您好,</p><br><br>您的电子薪资袋登入密码即将于<span style=\"color: #ff843f;\">[@到期時間@]</span>到期，<br><br>请您尽快前往「<b>ePortal>个人专区>个人资料查询>账号安全</b>」内维护变更您的密码，谢谢。<br><br><br>(本邮件为系统自动发送，请勿直接回复)"
	  }
	},
	"PAYSHEET_020": {
	  "name": "電子薪資袋密碼通知",
	  "zh_TW": {
		"subject": "電子薪資袋密碼通知",
		"content": "<p>[@員工姓名@] 您好：</p><p>您的電子薪資預設密碼為<span style=\"color: #ff843f;\">[@預設密碼項目內容@]</span>。<br/>請您儘快前往「<b>ePortal > 個人專區 > 薪資袋</b>」內維護變更您的密碼。<br/>謝謝。</p>"
	  },
	  "en_US": {
		"subject": "Electronic payroll password notification",
		"content": "<p>Hello, [@員工姓名@], </p><p>Your default electronic payroll password is <span style=\"color: #ff843f;\">[@預設密碼項目內容@]</span>.<br/>Please go to \"<b>ePortal >Personal Zone>Payroll</b>\" to maintain and change your password as soon as possible. <br/>Thank you.</p>"
	  },
	  "zh_CN": {
		"subject": "电子薪资袋密码通知",
		"content": "<p>[@員工姓名@] 您好：</p><p>您的电子薪资默认密码为<span style=\"color: #ff843f;\">[@預設密碼項目內容@]</span>。<br/>请您尽快前往「<b>ePortal > 个人专区 > 薪资袋</b>」内维护变更您的密码。<br/>谢谢。</p>"
	  }
	},
	"PAYSHEET_030": {
	  "name": "重設薪資袋密碼通知",
	  "zh_TW": {
		"subject": "重設薪資袋密碼通知",
		"content": "<p>您好：</p><p>我們收到您重設薪資密碼的要求，提醒您如未做過變更動作，煩請盡速聯絡承辦人。</p><p>為了您帳戶安全，此連結<span style=\"color: #ff843f;\">30分鐘內有效</span></p><p>請點擊下方按鈕或複製連結，依指令操作完成即能完成重新設定密碼。</p><p>{{> zh_TW/button btnText='重設連結'}}</p><p>或複製前往以下連結：</p><p>{{> zh_TW/link }}</p>"
	  },
	  "en_US": {
		"subject": "Payroll password reset notification",
		"content": "<p>Hello, </p><p>We received your request to reset your payroll password. As a reminder, if you did not make the change, please contact the person in charge as soon as possible. </p><p>For your account security, this link is <span style=\"color: #ff843f;\">valid only for 30 minutes.</span></p><p>Please click the following button or copy the link to reset your password according to the instructions. </p><p>{{> en_US/button btnText='Reset password '}}</p><p>Or copy and go to the following link:</p><p>{{> en_US/link }}</p>"
	  },
	  "zh_CN": {
		"subject": "重设薪资袋密码通知",
		"content": "<p>您好,</p><p>我们收到了您申请重设薪资袋密码的要求，提醒您: 如未做过变更动作，烦请尽速联络承办人。</p><p>为了您账户安全，此链接仅<span style=\"color: #ff843f;\">30 分钟内有效。</span></p><p>请点击下方按钮或是复制链接，依照指令操作即能完成重新设定密码。</p><p>{{> zh_CN/button btnText='重设密码'}}</p><p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p>"
	  }
	},
	"PAYSHEET_040": {
	  "name": "員工薪資袋密碼異常通知",
	  "zh_TW": {
		"subject": "員工薪資袋密碼異常通知",
		"content": "<p>[@HR姓名@]，您好,</p><p>員工 <span style=\"color: #ff843f;\">[@員工編號@] [@員工姓名@]</span> 已於 [@忘記密碼規則@] 小時(含)內，重覆點擊電子薪資袋忘記密碼超過 [@忘記密碼規則次數@] 次(含)；煩請您儘快前往104 HR Max系統【薪資>發放作業>員工薪資袋管理】處理此筆異常狀況，謝謝。</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "Staff payroll password anomaly notification",
		"content": "<p>Hello, [@HR姓名@], </p><p>The employee <span style=\"color: #ff843f;\">[@員工編號@] [@員工姓名@]</span> has clicked Forgot Password to Electronic Payroll more than [@忘記密碼規則次數@] times (inclusive) within [@忘記密碼規則@] hour(s) (inclusive). Please go to [Salary>Distribution Operations>Staff Payroll Management] on the 104 HR Max system to handle this anomaly as soon as possible. Thank you. </p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "员工薪资袋密码异常通知",
		"content": "<p>[@HR姓名@]，您好,</p><p>员工 <span style=\"color: #ff843f;\">[@員工編號@] [@員工姓名@]</span> 已于 [@忘記密碼規則@] 小时(含)内，重复点击电子薪资袋忘记密码超过 [@忘記密碼規則次數@] 次(含)；烦请您尽快前往104 HR Max系统【薪资>发放作业>员工薪资袋管理】处理此笔异常状况，谢谢。</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PAYSHEET_050": {
	  "name": "員工薪資袋忘記密碼通知",
	  "zh_TW": {
		"subject": "員工薪資袋忘記密碼通知",
		"content": "<p>[@HR姓名@]，您好,</p><p>員工 [@員工編號@] [@員工姓名@] 於<span style=\"color: #ff843f;\">[@提交時間@]</span> 提交薪資袋忘記密碼申請；煩請您撥空前往104 HR Max系統【薪資>發放作業>員工薪資袋管理】處理，謝謝。</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "Staff forgot payroll password notification",
		"content": "<p>Hello, [@HR姓名@], </p><p>The employee [@員工編號@] [@員工姓名@] submitted a forgot payroll password request at<span style=\"color: #ff843f;\">[@提交時間@]</span>. Please go to [Salary>Distribution Operations>Staff Payroll Management] on the HR Max system to process the request. Thank you. </p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "员工薪资袋忘记密码通知",
		"content": "<p>[@HR姓名@]，您好，</p><p>员工 [@員工編號@] [@員工姓名@] 于<span style=\"color: #ff843f;\">[@提交時間@]</span> 提交薪资袋忘记密码申请；烦请您拨空前往HR Max系统【薪资>发放作业>员工薪资袋管理】处理，谢谢。</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PAYSHEET_060": {
	  "name": "【重要通知】員工密碼鎖定通知",
	  "zh_TW": {
		"subject": "【重要通知】員工密碼鎖定通知",
		"content": "[@HR姓名@]，您好,<br><br>員工 [@員工編號@] [@員工姓名@] 因多次輸入薪資袋密碼錯誤，已將其密碼狀態轉為鎖定；煩請您撥空前往104 HR Max系統【薪資>發放作業>員工薪資袋管理】處理，謝謝。<br><br>（本郵件為系統自動發送，請勿直接回覆）"
	  },
	  "en_US": {
		"subject": "[Important Notification] Locked staff password notification",
		"content": "[@HR姓名@] Hello,<br><br>Employee[@員工編號@] [@員工姓名@] has had their password status locked due to multiple incorrect attempts to enter their salary pouch password. Kindly take the time to visit the 104 HR Max system under 【Payroll > Payroll Distribution > Employee Salary Pouch Management】 to handle this matter. Thank you.<br><br> (This email is automatically generated by the system. Please do not reply directly.)"
	  },
	  "zh_CN": {
		"subject": "【重要通知】员工密码锁定通知",
		"content": "[@HR姓名@]，您好，<br><br>员工 [@員工編號@]  [@員工姓名@] 因多次输入薪资袋密码错误，已将其密码状态转为锁定；烦请您拨空前往104 HR Max系统【薪资>发放作业>员工薪资袋管理】处理，谢谢。<br><br>（本邮件为系统自动发送，请勿直接回复）"
	  }
	},
	"PAYSHEET_200": {
	  "name": "薪資袋發放通知",
	  "zh_TW": {
		"subject": "薪資袋發放通知",
		"content": "<p>[@員工姓名@]先生/小姐，您好,</p><br><br>您的[@結檔名稱@]薪資袋已發放，請參考附件；<br><br>如有任何問題，煩請儘速聯絡管理者。<br><br><br><br>祝您有美好的一天！<br><br>（本郵件為系統自動發送，請勿直接回覆)"
	  },
	  "en_US": {
		"subject": "Payroll distribution notification",
		"content": "<p>Hello, Mr./Ms. [@員工姓名@], </p><br><br>Your [@結檔名稱@] payroll has been distributed. Please see the attachment. <br><br>For any questions, please contact the administrator as soon as possible. <br><br><br><br>Have a nice day! <br><br>(This email is automatically sent by the system. Please do not reply.)"
	  },
	  "zh_CN": {
		"subject": "薪资袋发放通知",
		"content": "<p>[@員工姓名@]先生/小姐，您好,</p><br><br>您的[@結檔名稱@]薪资袋已发放，请参考附件；<br><br>如有任何问题，烦请尽快联络管理者。<br><br><br><br>祝您有美好的一天！<br><br>（本邮件为系统自动发送，请勿直接回复)"
	  }
	},
	"PORTAL_040": {
	  "name": "【重要通知】Portal密碼變更提醒",
	  "zh_TW": {
		"subject": "【重要通知】Portal密碼變更提醒",
		"content": "<p>[@員工姓名@]先生/小姐，您好,</p><br><br>提醒您，您的Portal密碼即將於[@到期時間@]到期，到期後，將無法使用原密碼登入系統。<br><br>請您儘快前往「ePortal>個人專區>個人資料查詢>帳號安全」內維護您的密碼，謝謝。<br><br><br>（本郵件為系統自動發送，請勿直接回覆)"
	  },
	  "en_US": {
		"subject": "[Important Notification] Portal password change reminder",
		"content": "<p>Hello, Mr./Ms. [@員工姓名@], </p><br><br>As a reminder, your Portal password will soon expire at [@到期時間@]. After it expires, you will not be able to use it to log in to the system. <br><br>Please go to “ePortal >Personal Zone>Profile Search>Account Security” to maintain your password as soon as possible. <br><br><br>(This email is automatically sent by the system. Please do not reply.)"
	  },
	  "zh_CN": {
		"subject": "【重要通知】Portal密码变更提醒",
		"content": "<p>[@員工姓名@]先生/小姐，您好,</p><br><br>提醒您，您的Portal密码即将于[@到期時間@]到期，到期后，将无法使用原密码登入系统。<br><br>请您尽快前往「ePortal>个人专区>个人资料查询>账号安全」内维护您的密码，谢谢。<br><br><br>（本邮件为系统自动发送，请勿直接回复)"
	  }
	},
	"PORTAL_050": {
	  "name": "【個人資料維護】- 審核",
	  "zh_TW": {
		"subject": "【<EMP_NAME>】個人資料審核通知",
		"content": "<p>您好,</p><p>員工【<span style=\"color: #ff843f;\"><EMP_NAME><EMP_EN_NAME></span>】於 <span style=\"color: #ff843f;\"><C_DATETIME></span> 新增/維護 /修改 個人資料，<br>建議您先與該員工確認是否有異動個人資料 ，如確認無誤，<br>請點擊下方連結，進入審核頁面，並依照指令操作後，即能完成審核喔。</p><p><a href=\"<LINK>\" style=\"text-decoration: underline;color: #292929;\"><LINK></a></p>"
	  },
	  "en_US": {
		"subject": "[<EMP_NAME>] Profile review notification",
		"content": "<p>Hello, </p><p>The employee【<span style=\"color: #ff843f;\"><EMP_NAME><EMP_EN_NAME></span>】added/maintained/modified his/her profile at <span style=\"color: #ff843f;\"><C_DATETIME></span>.<br>It is advisable to confirm such profile change with the employee first. If the change is confirmed, <br>please click the following link to enter the review page and complete the review according to the instructions.</p><p><a href=\"<LINK>\" style=\"text-decoration: underline;color: #292929;\"><LINK></a></p>"
	  },
	  "zh_CN": {
		"subject": "【<EMP_NAME>】个人资料审核通知",
		"content": "<p>您好,</p><p>员工【<span style=\"color: #ff843f;\"><EMP_NAME><EMP_EN_NAME></span>】于 <span style=\"color: #ff843f;\"><C_DATETIME></span> 新增/维护 /修改 个人资料，<br>建议您先与该员工确认是否有异动个人资料 ，如确认无误，<br>请点击下方链接，进入审核页面，并依照指令操作后，即能完成审核喔。</p><p><a href=\"<LINK>\" style=\"text-decoration: underline;color: #292929;\"><LINK></a></p>"
	  }
	},
	"PORTAL_060": {
	  "name": "【重要通知】員工Portal忘記密碼通知",
	  "zh_TW": {
		"subject": "【重要通知】員工Portal忘記密碼通知",
		"content": "<p>[@HR姓名@] 您好：</p><p>員工 [@員工編號@] [@員工姓名@] 於 <span style=\"color: #ff843f;\">[@提交時間@]</span> 提交Portal忘記密碼申請。<br/>請點擊下方按鈕或複製連結進行處理，謝謝。<br/>{{> zh_TW/button btnText='帳號管理'}}</p><p>或複製前往以下連結：</p><p><a href=\"[@帳號管理連結@]\" style=\"text-decoration: underline;color: #292929;\">[@帳號管理連結@]</a></p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] Staff forgot password notification",
		"content": "<p>Hello, [@HR姓名@], </p><p>The employee [@員工編號@] [@員工姓名@] submitted a forgot Portal password request at <span style=\"color: #ff843f;\">[@提交時間@]</span>.<br/>Please click the following button or copy the link to process the request. Thank you. <br/>{{> en_US/button btnText='Account management '}}</p><p>Or copy and go to the following link: </p><p><a href=\"[@帳號管理連結@]\" style=\"text-decoration: underline;color: #292929;\">[@帳號管理連結@]</a></p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】员工Portal忘记密码通知",
		"content": "<p>[@HR姓名@] 您好：</p><p>员工 [@員工編號@] [@員工姓名@] 于 <span style=\"color: #ff843f;\">[@提交時間@]</span> 提交Portal忘记密码申请。<br/>请点击下方按钮或复制链接进行处理，谢谢。<br/>{{> zh_CN/button btnText='账号管理'}}</p><p>或复制前往以下链接：</p><p><a href=\"[@帳號管理連結@]\" style=\"text-decoration: underline;color: #292929;\">[@帳號管理連結@]</a></p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PORTAL_031": {
	  "name": "Portal帳號認證(AD帳密登入)",
	  "zh_TW": {
		"subject": "【重要通知】Portal帳號首次認證 (AD帳密登入)",
		"content": "<p>[@EMP_NAME@] 您好：</p><p>您的 Portal 帳號 「[@USER_ACCOUNT@]」已被建立。</p><p>為了您帳戶安全，此連結僅 <span style=\"color: #ff843f;\">24 小時內有效</span>。<br />請您撥空點擊下方藍字，即可啟用帳號。謝謝。</p><p>{{> zh_TW/button btnText='啟用帳號'}}</p><p>或複製前往以下連結：</p><p>{{> zh_TW/link }}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
	  },
	  "en_US": {
		"subject": "[Important Notification] First time Portal account verification (login with AD account and password)",
		"content": "<p>Hello, [@EMP_NAME@], </p><p>Your Portal account “[@USER_ACCOUNT@]” has been created.</p><p>For your account security, this link is <span style=\"color: #ff843f;\">valid only for 24 hours</span>.<br />Please click the following blue text to activate your account. Thank you. </p><p>{{> en_US/button btnText='Activate account '}}</p><p>Or copy and go to the following link:</p><p>{{> en_US/link }}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
	  },
	  "zh_CN": {
		"subject": "【重要通知】Portal账号首次认证 (AD帐密登入)",
		"content": "<p>[@EMP_NAME@] 您好：</p><p>您的 Portal 账号「[@USER_ACCOUNT@]」已被建立。</p><p>为了您账户安全，此链接仅 <span style=\"color: #ff843f;\">24 小时内有效</span>.<br />请您拨空点击下方蓝字，即可启用账号。谢谢。</p><p>{{> zh_CN/button btnText='启用账号'}}</p><p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
	  }
	},
	"PORTAL_032": {
		"name": "Portal帳號認證",
		"zh_TW": {
		  "subject": "【重要通知】Portal帳號首次認證",
		  "content": "<p>[@EMP_NAME@] 您好：</p><p>您的 Portal 帳號 「[@USER_ACCOUNT@]」已被建立。</p><p>為了您帳戶安全，此連結僅 <span style=\"color: #ff843f;\">24 小時內有效</span>。<br />請您撥空點擊下方藍字，即可啟用帳號。謝謝。</p><p>{{> zh_TW/button btnText='啟用帳號'}}</p><p>或複製前往以下連結：</p><p>{{> zh_TW/link }}</p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
		},
		"en_US": {
		  "subject": "[Important Notification] First time Portal account verification",
		  "content": "<p>Hello, [@EMP_NAME@], </p><p>Your Portal account “[@USER_ACCOUNT@]” has been created.</p><p>For your account security, this link is <span style=\"color: #ff843f;\">valid only for 24 hours</span>.<br />Please click the following blue text to activate your account. Thank you. </p><p>{{> en_US/button btnText='Activate account '}}</p><p>Or copy and go to the following link:</p><p>{{> en_US/link }}</p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
		},
		"zh_CN": {
		  "subject": "【重要通知】Portal账号首次认证",
		  "content": "<p>[@EMP_NAME@] 您好：</p><p>您的 Portal 账号「[@USER_ACCOUNT@]」已被建立。</p><p>为了您账户安全，此链接仅 <span style=\"color: #ff843f;\">24 小时内有效</span>.<br />请您拨空点击下方蓝字，即可启用账号。谢谢。</p><p>{{> zh_CN/button btnText='启用账号'}}</p><p>或复制前往以下链接：</p><p>{{> zh_CN/link }}</p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
		}
	},
	"SA_010": {
		"name": "班表催排通知",
		"zh_TW": {
		  "subject": "班表催排通知",
		  "content": "<p>[@員工姓名@] 您好：</p><p>您尚未完成[@班表名稱@]的預排作業。<br />提醒您請於<span style=\"color: #ff843f;\">[@預排結束時間@]</span>完成，謝謝。</p><p><table class=\"mail-button\" cellpadding=\"0\" cellspacing=\"0\" style=\"border: 1px solid #2e4fb4; background-color:#fff; color: #2e4fb4;\"><tbody><tr><td align=\"center\" height=\"32\" style=\"padding:0px 19px; height:38px; font-size:14px; line-height:12px\"><a href=\"[@班表預排網址@]\" target=\"_blank\" style=\"text-decoration:none; color:#2e4fb4;\">班表預排網址</a></td></tr></tbody></table></p><p>（本郵件為系統自動發送，請勿直接回覆）</p>"
		},
		"en_US": {
		  "subject": "Shift scheduling notification",
		  "content": "<p>Hello, [@員工姓名@], </p><p>You have not completed the pre-scheduling of [@班表名稱@]. <br />As a reminder, please complete it by<span style=\"color: #ff843f;\">[@預排結束時間@]</span>. Thank you. </p><p><table class=\"mail-button\" cellpadding=\"0\" cellspacing=\"0\" style=\"border: 1px solid #2e4fb4; background-color:#fff; color: #2e4fb4;\"><tbody><tr><td align=\"center\" height=\"32\" style=\"padding:0px 19px; height:38px; font-size:14px; line-height:12px\"><a href=\"[@班表預排網址@]\" target=\"_blank\" style=\"text-decoration:none; color:#2e4fb4;\">Shift Pre-scheduling Link</a></td></tr></tbody></table></p><p>(This email is automatically sent by the system. Please do not reply.)</p>"
		},
		"zh_CN": {
		  "subject": "班表催排通知",
		  "content": "<p>[@員工姓名@] 您好：</p><p>您尚未完成[@班表名稱@]的预排作业。<br />提醒您请于<span style=\"color: #ff843f;\">[@預排結束時間@]</span>完成，谢谢。</p><p><table class=\"mail-button\" cellpadding=\"0\" cellspacing=\"0\" style=\"border: 1px solid #2e4fb4; background-color:#fff; color: #2e4fb4;\"><tbody><tr><td align=\"center\" height=\"32\" style=\"padding:0px 19px; height:38px; font-size:14px; line-height:12px\"><a href=\"[@班表預排網址@]\" target=\"_blank\" style=\"text-decoration:none; color:#2e4fb4;\">班表预排网址</a></td></tr></tbody></table></p><p>（本邮件为系统自动发送，请勿直接回复）</p>"
		}
	},
	EHRMS_005: {
		name: '使用者帳號認證信',
		zh_TW: {
			subject: '【重要通知】104 HR Max系統帳號認證',
			content: `<p>[@USER_NAME@]先生/小姐，您好,</p>
			<p>您的 104 HR Max 帳號 「<b>[@USER_ACCOUNT@]</b>」已被建立。</p>
			<p>為了您帳戶安全，此連結僅<spanstyle=\"color:#ff843f;\">24小時內有效</span>。</p>
			<p>請點擊下方藍字，依照指令操作即能啟用您的帳號。</p>
			{{>zh_TW/buttonbtnText='啟用帳號'}}
			<p>或複製前往以下連結：</p>
			<p>{{>zh_TW/link}}</p>
			<p>啟用帳號後，請再以手機的 Authenticator APP 掃描附件 QR code檔案，以進行 HR Max OTP 註冊作業。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本郵件為系統自動發送，請勿直接回覆）</p>`,
		},
		en_US: {
			subject: '[ImportantNotification]104HRMaxsystemaccountverification',
			content: `<p>Hello, Mr./Ms. [@USER_NAME@], </p>
			<p>Your 104 HR Max account “[@USER_ACCOUNT@]” has been created. </p>
			<p>For your account security, this link is<span style=\"color: #ff843f;\"> valid only for 24 hours. </span>。</p>
			<p>Please click the following blue text to activate your account according to the instructions. </p>
			{{> en_US/button btnText='Activate account '}}
			<p>Or copy and go to the following link: </p>
			<p>{{> en_US/link }}</p>
			<p>After activating the accpunt, please use the Authenticator APP to scan the QR code to generate the HR Max OTP code. </p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>(This email is automatically sent by the system. Please do not reply.)</p>`,
		},
		zh_CN: {
			subject: '【重要通知】104 HR Max系统账号认证',
			content: `<p>[@USER_NAME@]先生/小姐，您好,</p>
			<p>您的 104 HR Max 账号 「<b>[@USER_ACCOUNT@]</b>」已建立。</p>
			<p>为了您账户安全，此链接仅<span style=\"color: #ff843f;\"> 24 小时内有效</span>。</p>
			<p>请点击下方蓝字，依照指令操作即能启用您的账号。</p>
			{{> zh_CN/button btnText='启用账号'}}
			<p>或复制前往以下链接：</p>
			<p>{{> zh_CN/link }}</p>
			<p>启用帐号后，请再以手机的 Authenticator APP 扫描附件 QR code档案，以进行 HR Max OTP 注册作业。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本邮件为系统自动发送，请勿直接回复）</p>`,
		},
	},
	PORTAL_033: {
		name: '【重要通知】Portal帳號首次認證 (帳密驗證)',
		zh_TW: {
			subject: '【重要通知】Portal帳號首次認證',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>您的 Portal 帳號 「[@USER_ACCOUNT@]」已被建立，公司代號為「[@APP_COMPANY_CODE@]」。</p>
			<p>為了您帳戶安全，此連結僅 <span style=\"color: #ff843f;\">24 小時內有效</span>。
			<br />請點擊下方藍字，依照指令操作即能啟用您的帳號。</p>
			<p>{{> zh_TW/button btnText='啟用帳號'}}</p>
			<p>或複製前往以下連結：</p>
			<p>{{> zh_TW/link }}</p>
			<p>啟用帳號後，請再以手機的 Authenticator APP 掃描附件 QR code檔案，以進行 Portal OTP 註冊作業。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本郵件為系統自動發送，請勿直接回覆）</p>`,
		},
		en_US: {
			subject: '[Important Notification] First time Portal account verification',
			content: `<p>Hello, [@EMP_NAME@], </p>
			<p>Your Portal account “[@USER_ACCOUNT@]” has been created, and the company code is “[@APP_COMPANY_CODE@].” </p>
			<p>For your account security, this link is <span style=\"color: #ff843f;\">valid only for 24 hours</span>.
			<br />Please click the following blue text to activate your account according to the instructions. </p>
			<p>{{> en_US/button btnText='Activate account '}}</p>
			<p>Or copy and go to the following link:</p>
			<p>{{> en_US/link }}</p>
			<p>After activating the accpunt, please use the Authenticator APP to scan the QR code to generate the Portal OTP code. </p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>(This email is automatically sent by the system. Please do not reply.)</p>`,
		},
		zh_CN: {
			subject: '【重要通知】Portal账号首次认证',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>您的 Portal 账号 「[@USER_ACCOUNT@]」已被建立，公司代号为「[@APP_COMPANY_CODE@]」。</p>
			<p>为了您账户安全，此链接仅 <span style=\"color: #ff843f;\">24 小时内有效</span>。
			<br />请点击下方蓝字，依照指令操作即能启用您的账号。</p>
			<p>{{> zh_CN/button btnText='启用账号'}}</p>
			<p>或复制前往以下链接：</p>
			<p>{{> zh_CN/link }}</p>
			<p>启用帐号后，请再以手机的 Authenticator APP 扫描附件 QR code档案，以进行 Portal OTP 注册作业。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本邮件为系统自动发送，请勿直接回复）</p>`,
		},
	},
	PORTAL_034: {
		name: '【重要通知】Portal帳號首次認證 (AD帳密登入)',
		zh_TW: {
			subject: '【重要通知】Portal帳號首次認證',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>您的 Portal 帳號 「[@USER_ACCOUNT@]」已被建立。</p>
			<p>為了您帳戶安全，此連結僅 <span style=\"color: #ff843f;\">24 小時內有效</span>。
			<br />請您撥空點擊下方藍字，即可啟用帳號。謝謝。</p>
			<p>{{> zh_TW/button btnText='啟用帳號'}}</p>
			<p>或複製前往以下連結：</p>
			<p>{{> zh_TW/link }}</p>
			<p>啟用帳號後，請再以手機的 Authenticator APP 掃描附件 QR code檔案，以進行 Portal OTP 註冊作業。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本郵件為系統自動發送，請勿直接回覆）</p>`,
		},
		en_US: {
			subject: '[Important Notification] First time Portal account verification (login with AD account and password)',
			content: `<p>Hello, [@EMP_NAME@], </p>
			<p>Your Portal account “[@USER_ACCOUNT@]” has been created.</p>
			<p>For your account security, this link is <span style=\"color: #ff843f;\">valid only for 24 hours</span>.
			<br />Please click the following blue text to activate your account. Thank you. </p>
			<p>{{> en_US/button btnText='Activate account '}}</p>
			<p>Or copy and go to the following link:</p>
			<p>{{> en_US/link }}</p>
			<p>After activating the accpunt, please use the Authenticator APP to scan the QR code to generate the Portal OTP code. </p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>(This email is automatically sent by the system. Please do not reply.)</p>`,
		},
		zh_CN: {
			subject: '【重要通知】Portal账号首次认证 (AD帐密登入)',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>您的 Portal 账号「[@USER_ACCOUNT@]」已被建立。</p>
			<p>为了您账户安全，此链接仅 <span style=\"color: #ff843f;\">24 小时内有效</span>.
			<br />请您拨空点击下方蓝字，即可启用账号。谢谢。</p>
			<p>{{> zh_CN/button btnText='启用账号'}}</p>
			<p>或复制前往以下链接：</p>
			<p>{{> zh_CN/link }}</p>
			<p>启用帐号后，请再以手机的 Authenticator APP 扫描附件 QR code档案，以进行 Portal OTP 注册作业。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本邮件为系统自动发送，请勿直接回复）</p>`,
		},
	},
	OTP_010: {
		name: '【重要通知】Portal OTP 密碼通知',
		zh_TW: {
			subject: '【重要通知】Portal OTP 密碼通知',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>請以手機的 Authenticator APP 掃描附件 QR code檔案，以進行 Portal OTP 註冊作業。謝謝。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本郵件為系統自動發送，請勿直接回覆）</p>`,
		},
		en_US: {
			subject: '[Important Notification] Portal OTP password notification',
			content: `<p>Hello, [@EMP_NAME@], </p>
			<p>Please use the Authenticator APP to scan the QR code to generate the Portal OTP code. Thanks.</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>(This email is automatically sent by the system. Please do not reply.)</p>`,
		},
		zh_CN: {
			subject: '【重要通知】Portal OTP 密码通知',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>请以手机的 Authenticator APP 扫描附件 QR code档案，以进行 Portal OTP 注册作业。谢谢。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本邮件为系统自动发送，请勿直接回复）</p>`,
		},
	},
	OTP_020: {
		name: '【重要通知】HR Max OTP 密碼通知',
		zh_TW: {
			subject: '【重要通知】HR Max OTP 密碼通知',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>請以手機的 Authenticator APP 掃描附件 QR code檔案，以進行 HR Max OTP 註冊作業。謝謝。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本郵件為系統自動發送，請勿直接回覆）</p>`,
		},
		en_US: {
			subject: '[Important Notification] HR Max OTP password notification',
			content: `<p>Hello, [@EMP_NAME@], </p>
			<p>Please use the Authenticator APP to scan the QR code to generate the HR Max OTP code. Thanks.</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>(This email is automatically sent by the system. Please do not reply.)</p>`,
		},
		zh_CN: {
			subject: '【重要通知】HR Max OTP 密码通知',
			content: `<p>[@EMP_NAME@] 您好：</p>
			<p>请以手机的 Authenticator APP 扫描附件 QR code档案，以进行 HR Max OTP 注册作业。谢谢。</p>
			<p><img alt="[@OTP_KEY@]" src="[@QR code 圖檔@]" /></p>
			<p>（本邮件为系统自动发送，请勿直接回复）</p>`,
		},
	},
	REG_010: {
		name: '【重要通知】員工申請解除手機綁定驗證函',
		zh_TW: {
			subject: '【重要通知】員工申請解除手機綁定驗證函',
			content: `
				<p>[@EMP_NAME@] 您好：</p></br>
				<p>為了您帳戶安全，請先確認是否有點擊過APP「申請解除綁定」功能。</p>
				<p>若確認無誤，您可點擊下方連結 <span style="color: #ff843f;font-weight: bold;">（有效時間 [@VALID_TIME@]）</span> 並成功驗證個人身份後，即可自動解除手機綁定。謝謝。</p></br>
				<p>{{> zh_TW/button btnText='驗證身份'}}</p></br>
				<p>或複製前往以下連結：</p>
				<p>{{> zh_TW/link }}</p></br>
				<p>謝謝。</p></br>
				<p>（本郵件為系統自動發送，請勿直接回覆）</p>
			`,
		},
		en_US: {
			subject: '[Important Notification] Employee applied for the release of phone binding verification',
			content: `
				<p>Hello, [@EMP_NAME@], </p></br>
				<p>For your account security, please confirm whether you have clicked on the "Apply to Unbind" feature in the app.</p></br>
				<p>If everything is correct, you can click the link below <span style="color: #ff843f;font-weight: bold;">(valid until [@VALID_TIME@])</span> and verify your personal identity. This will automatically unbind your mobile phone. Thank you.</p></br>
				<p>{{> en_US/button btnText='Verify Identity'}}</p></br>
				<p>Or copy and go to the following link:</p>
				<p>{{> en_US/link }}</p></br>
				<p>Thank you.</p></br>
				<p>(This email is automatically sent by the system. Please do not reply.)</p>
			`,
		},
		zh_CN: {
			subject: '【重要通知】员工申请解除手机绑定验证函',
			content: `
				<p>[@EMP_NAME@] 您好：</p></br>
				<p>为了您账户安全，请先确认是否有点击过APP「申请解除绑定」功能。</p>
				<p>若确认无误，您可点击下方连结 <span style="color: #ff843f;font-weight: bold;">（有效时间 [@VALID_TIME@]）</span> 并成功验证个人身份后，即可自动解除手机绑定。谢谢。</p></br>
				<p>{{> zh_CN/button btnText='验证身份'}}</p></br>
				<p>或复制前往以下连结：</p>
				<p>{{> zh_CN/link }}</p></br>
				<p>谢谢。</p></br>
				<p>（本邮件为系统自动发送，请勿直接回复）</p>
			`,
		},
	},	
	CE_010: {
		name: '通勤方式催填通知',
		zh_TW: {
			subject: '通勤方式催填通知',
			content: `<p>[@EMP_NAME@] 您好：</p>
				<p>近年來台灣政府積極推動公司設定減碳目標，並鼓勵企業揭露溫室氣體「範疇三」資訊，其中包含員工通勤所產生之碳排放量。</p>
				<p>我們希望透過了解員工通勤模式，計算員工通勤碳排，以響應政策。</p>
				<p>您的參與對於我們制定更符合需求的改善方案至關重要，提醒您尚未填寫通勤方式，請儘速完成，謝謝。</p>
				<p>（本郵件為系統自動發送，請勿直接回覆）</p>`,
		},
		en_US: {
			subject: 'Commute method reminder notification',
			content: `<p>Hello, [@EMP_NAME@], </p>
				<p>In recent years, the Taiwanese government has actively promoted companies to set carbon reduction targets and encouraged the disclosure of greenhouse gas "Scope 3" emissions, including carbon emissions generated from employee commuting.</p>
				<p>We aim to understand commuting patterns in order to calculate employee commuting carbon emissions in response to these policies.</p>
				<p>Your participation is essential for us to develop solutions that better meet actual needs. This is a reminder that your commuting method has not yet been submitted. Please complete the form as soon as possible. Thank you.</p>
				<p>(This email is automatically sent by the system. Please do not reply.)</p>`,
		},
		zh_CN: {
			subject: '通勤方式催填通知',
			content: `<p>[@EMP_NAME@] 您好：</p>
				<p>近年来，台湾政府积极推动企业设定减碳目标，并鼓励企业揭露温室气体“范畴三”资讯，其中包含员工通勤所产生的碳排放量。</p>
				<p>我们希望通过了解员工的通勤模式，计算通勤碳排放量，以响应相关政策。</p>
				<p>您的参与对我们制定更符合需求的改进方案至关重要。提醒您尚未填写通勤方式，请尽快完成填写，谢谢。</p>
				<p>（本邮件为系统自动发送，请勿直接回复）</p>`,
		},
	},
	EP_140: {
		name: '表單異常通知',
		zh_TW: {
			subject: '[@表單名稱@] [@表單單號@] 系統異常通知',
			content: `<p>[@收件人_中文名@] [@收件人_英文名@] 您好：</p></br></br>
				<p>[@申請者_中文名@] [@申請者_英文名@] 所申請的 [@表單名稱@] [@表單單號@] ，因系統異常，資料無法寫入後台。</p></br>
				<p>造成不便，敬請見諒。</p></br></br></br>
				<p>如有任何疑問，請洽詢表單承辦人。</p></br>
				<p>承辦人員：[@承辦人_中文名@] [@承辦人_英文名@]</p></br>
				<p>辦公電話：[@承辦人電話@]</p></br>
				<p>e-mail ：[@承辦人EMail@]</p></br></br>
				<p>謝謝</p></br></br>
				<p>（本郵件為系統自動發送，請勿直接回覆）</p>`,
		},
		en_US: {
			subject: '[@表單名稱@] [@表單單號@] System anomaly notification',
			content: `<p>Dear [@收件人_中文名@] [@收件人_英文名@] ,</p></br></br>
				<p>Due to a system error, the [@表單名稱@] [@表單單號@] applied by [@申請者_中文名@] [@申請者_英文名@] could not be successfully recorded in the system.</p></br></br>
				<p>We apologize for any inconvenience caused.</p></br></br></br>
				<p>For any questions, please contact the person in charge. </p></br>
				<p>Person in charge: [@承辦人_中文名@] [@承辦人_英文名@]</p></br>
				<p>Tel.: [@承辦人電話@] </p></br>
				<p>E-mail: [@承辦人EMail@] </p></br>
				<p>Thank you.</p></br></br>
				<p>(This email is automatically sent by the system. Please do not reply.)</p>`,
		},
		zh_CN: {
			subject: '[@表單名稱@] [@表單單號@] 系統異常通知',
			content: `<p>[@收件人_中文名@] [@收件人_英文名@] 您好：</p></br></br>
				<p>[@申請者_中文名@] [@申請者_英文名@] 所申请的[@表單名稱@] [@表單單號@]，因系统异常，数据无法写入后台。</p></br>
				<p>带来不便，敬请谅解。</p></br></br></br>
				<p>如有任何疑问，请联系表单承办人。</p></br>
				<p>承办人员：[@承辦人_中文名@] [@承辦人_英文名@]</p></br>
				<p>办公电话：[@承辦人電話@]</p></br>
				<p>电子邮箱：[@承辦人EMail@]</p></br></br>
				<p>谢谢</p></br></br>
				<p>（本邮件为系统自动发送，请勿直接回复）</p>`,
		},
	},
	
  });
